import { auditMarketingSitemap } from './marketingSitemapAudit.js';
import type { MarketingSeoPreviewBranding } from './marketingSeoPreview.js';
import type { PublicMarketingConfig } from './publicMarketingConfig.js';

export type MarketingSitemapXmlEntry = {
  loc: string;
  lastmod?: string;
};

function escapeXml(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&apos;');
}

/** Build sitemap.org XML from canonical marketing URLs. */
export function buildMarketingSitemapXml(entries: MarketingSitemapXmlEntry[]): string {
  const body = entries
    .map((entry) => {
      const lastmod = entry.lastmod ? `\n    <lastmod>${escapeXml(entry.lastmod)}</lastmod>` : '';
      return `  <url>\n    <loc>${escapeXml(entry.loc)}</loc>${lastmod}\n  </url>`;
    })
    .join('\n');

  return `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
${body}
</urlset>
`;
}

/** Tenant sitemap XML from resolved public marketing config and branding. */
export function buildTenantMarketingSitemapXml(
  config: PublicMarketingConfig,
  branding: MarketingSeoPreviewBranding,
  options?: { lastmod?: string },
): string {
  const rows = auditMarketingSitemap(config, branding);
  return buildMarketingSitemapXml(
    rows.map((row) => ({
      loc: row.canonicalUrl,
      lastmod: options?.lastmod,
    })),
  );
}

/** Preview tenant sitemap.xml in admin SEO panel. */
export function buildTenantMarketingSitemapPreview(
  config: PublicMarketingConfig,
  branding: MarketingSeoPreviewBranding,
): { xml: string; urlCount: number } {
  const rows = auditMarketingSitemap(config, branding);
  return {
    xml: buildTenantMarketingSitemapXml(config, branding),
    urlCount: rows.length,
  };
}
